(function () {
  var configScript = document.getElementById("posthog-session-replay-config");
  if (!configScript) return;

  var posthogState = window.__THEME_POSTHOG_REPLAY__ || {
    initialized: false,
    initRequested: false,
    consentListenerBound: false,
  };
  window.__THEME_POSTHOG_REPLAY__ = posthogState;

  function parseConfig() {
    try {
      return JSON.parse(configScript.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  var config = parseConfig();
  if (!config || !config.enabled) return;

  var SESSION_SAMPLE_STORAGE_KEY = "theme-posthog-replay-sampled-v1";
  var DISTINCT_ID_STORAGE_KEY = "popup-builder-posthog-distinct-id";
  var CONSENT_API_POLL_INTERVAL_MS = 50;
  var CONSENT_API_POLL_TIMEOUT_MS = 5000;
  var SENSITIVE_TEXT_CLASS = "theme-posthog-mask-text";
  var sensitiveTextObserver = null;
  var SENSITIVE_TEXT_SELECTORS = [
    ".newsletter-form",
    ".newsletter__subheading",
    ".contact",
    ".contact-form",
    "#ContactForm",
    "#Cart-note",
    ".cart__note",
    ".gift-card-recipient-form",
    ".shopify-email-marketing-confirmation__container",
    ".article-template__comment-wrapper",
    "[href^='mailto:']",
  ];

  function createAnonymousDistinctId() {
    try {
      var existingValue = window.localStorage.getItem(DISTINCT_ID_STORAGE_KEY);
      if (existingValue) return existingValue;

      var createdValue =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : "thr_" + Math.random().toString(36).slice(2) + Date.now().toString(36);

      window.localStorage.setItem(DISTINCT_ID_STORAGE_KEY, createdValue);
      return createdValue;
    } catch (error) {
      return "thr_ephemeral_" + Date.now().toString(36);
    }
  }

  function isSampledInSession() {
    try {
      var existingValue = window.sessionStorage.getItem(SESSION_SAMPLE_STORAGE_KEY);
      if (existingValue === "1") return true;
      if (existingValue === "0") return false;

      var isSampled = Math.random() < config.sampleRate;
      window.sessionStorage.setItem(SESSION_SAMPLE_STORAGE_KEY, isSampled ? "1" : "0");
      return isSampled;
    } catch (error) {
      return Math.random() < config.sampleRate;
    }
  }

  function analyticsConsentGranted() {
    return !!(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function" &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function withConsentApi(onReady) {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function"
    ) {
      onReady();
      return;
    }

    if (
      window.Shopify &&
      window.Shopify.loadFeatures &&
      window.Shopify.trackingConsent
    ) {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function () {
          if (
            window.Shopify &&
            window.Shopify.customerPrivacy &&
            typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function"
          ) {
            onReady();
          }
        },
      );
      return;
    }

    var startedAt = Date.now();
    var pollId = window.setInterval(function () {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function"
      ) {
        window.clearInterval(pollId);
        onReady();
        return;
      }

      if (Date.now() - startedAt >= CONSENT_API_POLL_TIMEOUT_MS) {
        window.clearInterval(pollId);
      }
    }, CONSENT_API_POLL_INTERVAL_MS);
  }

  function stopReplayIfRunning() {
    if (!window.posthog || typeof window.posthog.stopSessionRecording !== "function") {
      return;
    }

    try {
      window.posthog.stopSessionRecording();
    } catch (error) {
      // Ignore recorder shutdown failures.
    }
  }

  function markSensitiveTextNodes(root) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    SENSITIVE_TEXT_SELECTORS.forEach(function (selector) {
      var elements;

      try {
        elements = root.querySelectorAll(selector);
      } catch (error) {
        elements = [];
      }

      Array.prototype.forEach.call(elements, function (element) {
        element.classList.add(SENSITIVE_TEXT_CLASS);
      });
    });
  }

  function ensureSensitiveTextMasking() {
    markSensitiveTextNodes(document);

    if (sensitiveTextObserver) return;

    sensitiveTextObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) {
            if (node.classList) {
              SENSITIVE_TEXT_SELECTORS.forEach(function (selector) {
                try {
                  if (node.matches(selector)) {
                    node.classList.add(SENSITIVE_TEXT_CLASS);
                  }
                } catch (error) {
                  // Ignore selector matching failures.
                }
              });
            }

            markSensitiveTextNodes(node);
          }
        });
      });
    });

    sensitiveTextObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function startReplayIfPossible(options) {
    if (!window.posthog || typeof window.posthog.startSessionRecording !== "function") {
      return;
    }

    try {
      window.posthog.startSessionRecording(options || {});
    } catch (error) {
      // Ignore recorder startup failures.
    }
  }

  function initReplay() {
    if (posthogState.initialized || posthogState.initRequested) return;
    if (!window.posthog || typeof window.posthog.init !== "function") return;

    posthogState.initRequested = true;
    var distinctId = createAnonymousDistinctId();
    ensureSensitiveTextMasking();

    window.posthog.init(config.projectToken, {
      api_host: config.apiHost,
      defaults: "2026-01-30",
      autocapture: false,
      capture_pageview: false,
      persistence: "localStorage+cookie",
      loaded: function (posthog) {
        posthogState.initialized = true;
        posthogState.initRequested = false;

        try {
          posthog.register({
            shop_domain: config.shopDomain,
            replay_scope: config.pageType,
          });
          posthog.identify(distinctId);
        } catch (error) {
          // Ignore anonymous storefront identify failures.
        }

        startReplayIfPossible();
      },
      session_recording: {
        sampleRate: 1,
        maskAllInputs: true,
        maskTextSelector: "." + SENSITIVE_TEXT_CLASS,
        maskCapturedNetworkRequestFn: function (request) {
          if (request && request.name) {
            request.name = request.name.split("?")[0];
          }

          if (request && request.headers) {
            request.headers = {};
          }

          if (request && request.body) {
            request.body = "[REDACTED]";
          }

          return request;
        },
      },
    });
  }

  function evaluateReplayState() {
    if (!analyticsConsentGranted()) {
      stopReplayIfRunning();
      return;
    }

    if (!isSampledInSession()) {
      return;
    }

    if (posthogState.initialized) {
      startReplayIfPossible();
      return;
    }

    initReplay();
  }

  function bindConsentListeners() {
    if (posthogState.consentListenerBound) return;
    posthogState.consentListenerBound = true;

    window.addEventListener("PandectesEvent_OnConsent", function () {
      window.setTimeout(evaluateReplayState, 0);
    });
  }

  bindConsentListeners();
  withConsentApi(evaluateReplayState);
})();
